import React, { useEffect, useState } from "react";
import InputMain from "../Main/InputMain";
import SelectMain from "../Main/SelectMain";
import InfoMain from "../Main/InfoMain";
import MaintenanceService from "../../../services/maintenance";
import EquipmentService from "../../../services/equipment";
import { simpleAlerts } from "../../../utils/alerts";
import { CODES } from "../../../utils/httpCodes";

const BodyGenerateMaintenance = ({
  setTitleLoad,
  setActiveTab,
  url,
  handleOpenLoad,
  handleCloseLoad,
  tiposMantenimiento,
  setTiposMantenimiento,
}) => {
  const [search, setSearch] = useState("");
  const [infoEquipment, setInfoEquipment] = useState(null);

  const [dataMaintenance, setDataMaintenance] = useState({
    equipo_id: null,
    tipo_mantenimiento_id: null,
    fecha: "",
    observacion: "",
  });

  const searchEquipment = async () => {
    if (!search) {
      alert("Ingrese Serie o IMEI");
      return;
    }
    try {
      setTitleLoad("Buscando equipo...");

      const result = await EquipmentService.searchBySerieOrImei(url, search);

      if (!result.data) {
        alert("Equipo no encontrado");
        return;
      }

      const equipo = result.data;

      setInfoEquipment(equipo);

      setDataMaintenance({
        ...dataMaintenance,
        equipo_id: equipo.id_equipo,
      });
    } catch (error) {
      console.log(error);
      alert("Error buscando equipo");
    }
  };

  const saveMaintenance = async () => {
    if (!dataMaintenance.equipo_id) {
      simpleAlerts("Debe seleccionar un equipo", "warning");
      return;
    }

    if (!dataMaintenance.tipo_mantenimiento_id) {
      simpleAlerts("Debe seleccionar tipo de mantenimiento", "warning");
      return;
    }

    if (!dataMaintenance.fecha) {
      simpleAlerts("Debe seleccionar una fecha", "warning");
      return;
    }

    try {
      handleOpenLoad();
      setTitleLoad("Registrando mantenimiento...");
      const result = await MaintenanceService.createMaintenance(
        url,
        dataMaintenance,
      );
      if (result.status === CODES.CREATE_201) {
        simpleAlerts(result?.data?.message || "Guardado", "success");
        setSearch("");
        setInfoEquipment(null);
        setDataMaintenance({
          equipo_id: null,
          tipo_mantenimiento_id: null,
          observacion: "",
        });
        handleCloseLoad();
      } else {
        simpleAlerts(
          result?.response?.data?.message || "Error en el guardado",
          "error",
        );
        handleCloseLoad();
        setTitleLoad(null);
      }
    } catch (error) {
      console.log(error);
      alert("Error registrando mantenimiento");
    }
  };

  return (
    <div className="row justify-content-center align-items-center">
      <div
        className="col-md-7 col-sm-12 border mt-2 body-main"
        style={{ height: "85vh" }}
      >
        <SelectMain
          titleColor={"black"}
          title={"Tipo de mantenimiento"}
          placeholder={"Seleccionar tipo"}
          options={tiposMantenimiento}
          value={dataMaintenance.tipo_mantenimiento_id}
          onChange={(value) =>
            setDataMaintenance({
              ...dataMaintenance,
              tipo_mantenimiento_id: value,
            })
          }
        />
        <InputMain
          type="date"
          title={"Fecha de mantenimiento"}
          titleColor={"black"}
          value={dataMaintenance.fecha}
          onChange={(e) =>
            setDataMaintenance({
              ...dataMaintenance,
              fecha: e.target.value,
            })
          }
        />
        <div className="d-flex align-items-end">
          <InputMain
            titleColor={"black"}
            title={"Buscar equipo"}
            placeholder={"Serie o IMEI"}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            className="btn btn-outline-dark btn-sm mb-1 btn-group-custom"
            onClick={searchEquipment}
          >
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
        </div>
        {/* AUTOCOMPLETE INFO */}
        {infoEquipment && (
          <div className="mt-4">
            <InputMain
              titleColor={"black"}
              title={"Equipo"}
              value={infoEquipment?.nombre}
            />
            <InputMain
              titleColor={"black"}
              title={"Marca - Modelo"}
              value={`${infoEquipment?.marca} ${infoEquipment?.modelo}`}
            />

            <InputMain
              titleColor={"black"}
              title={"Característica"}
              value={infoEquipment?.caracteristica || "--"}
            />
            <InputMain
              titleColor={"black"}
              title={"CECO"}
              value={infoEquipment?.ceco || "--"}
            />

            <InputMain
              titleColor={"black"}
              title={"Serie"}
              value={infoEquipment?.nroSerie}
            />
          </div>
        )}
        <div className="d-flex justify-content-center mt-3">
          <button className="btn btn-success" onClick={saveMaintenance}>
            Registrar mantenimiento
          </button>
        </div>
      </div>
    </div>
  );
};

export default BodyGenerateMaintenance;
